"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sizes = ['small', 'medium'];

var RunIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RunIcon, _React$PureComponent);

  function RunIcon() {
    _classCallCheck(this, RunIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(RunIcon).apply(this, arguments));
  }

  _createClass(RunIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className"]);
      /* eslint-disable max-len */


      var svgs = {
        small: {
          viewBox: '0 0 8 8',
          // TODO: path is not the right one, it's a temporary version
          // based on the medium one shrinked to 8x8
          // need to pick the exact unique shape once provided by the design team
          path: _react.default.createElement("path", {
            fill: color,
            d: "M1.33333333,1.74313333 L1.33333333,6.25713333 C1.33333333,6.8678 2,7.24513333 2.524,6.93046667 L6.28533333,4.6738 C6.794,4.36846667 6.794,3.63113333 6.28533333,3.32646667 L2.524,1.06913333 C2,0.755133333 1.33333333,1.1318 1.33333333,1.74313333"
          })
        },
        medium: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("path", {
            fill: color,
            d: "M2,2.6147 L2,9.3857 C2,10.3017 3,10.8677 3.786,10.3957 L9.428,7.0107 C10.191,6.5527 10.191,5.4467 9.428,4.9897 L3.786,1.6037 C3,1.1327 2,1.6977 2,2.6147"
          })
        }
      };
      /* eslint-enable max-len */

      var svg = svgs[size];
      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'run-icon'),
        viewBox: svg.viewBox,
        size: size
      }, props), svg.path);
    }
  }]);

  return RunIcon;
}(_react.default.PureComponent);

exports.default = RunIcon;
RunIcon.defaultProps = {
  size: 'medium',
  color: 'inherit'
};
RunIcon.propTypes = {
  size: _propTypes.default.oneOf(sizes),
  className: _propTypes.default.string,
  color: _propTypes.default.string
};